import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { clsx } from 'clsx';
import * as React from 'react';
/**
 * Button component using Radix Slot for composition
 */
export const Button = React.forwardRef(({ className, variant = 'primary', size = 'md', asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, { ref: ref, className: clsx('button', `button--${variant}`, `button--${size}`, className), ...props }));
});
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map